import { render, staticRenderFns } from "./WarningSettingForm.vue?vue&type=template&id=37810218&scoped=true&"
import script from "./WarningSettingForm.vue?vue&type=script&lang=js&"
export * from "./WarningSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37810218",
  null
  
)

export default component.exports